// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"374":"1a3d9123","858":"0d10dfc8"}[chunkId] + ".chunk.js";
};